"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.offAccountChanged = exports.onAccountChanged = exports.signDirect = exports.signAmino = exports.addChain = exports.requestAccount = exports.getAccount = exports.getSupportedChains = void 0;
function getSupportedChains() {
    return window.cosmostation.tendermint.request({ method: 'ten_supportedChainNames' });
}
exports.getSupportedChains = getSupportedChains;
function getAccount(chainName) {
    return window.cosmostation.tendermint.request({ method: 'ten_account', params: { chainName: chainName } });
}
exports.getAccount = getAccount;
function requestAccount(chainName) {
    return window.cosmostation.tendermint.request({ method: 'ten_requestAccount', params: { chainName: chainName } });
}
exports.requestAccount = requestAccount;
function addChain(chain) {
    return window.cosmostation.tendermint.request({ method: 'ten_addChain', params: __assign({}, chain) });
}
exports.addChain = addChain;
function signAmino(chainName, doc, options) {
    return window.cosmostation.tendermint.request({
        method: 'ten_signAmino',
        params: { chainName: chainName, doc: doc, isEditMemo: !!(options === null || options === void 0 ? void 0 : options.memo), isEditFee: !!(options === null || options === void 0 ? void 0 : options.fee), gasRate: options === null || options === void 0 ? void 0 : options.gasRate },
    });
}
exports.signAmino = signAmino;
function signDirect(chainName, doc, options) {
    return window.cosmostation.tendermint.request({
        method: 'ten_signDirect',
        params: { chainName: chainName, doc: doc, isEditMemo: !!(options === null || options === void 0 ? void 0 : options.memo), isEditFee: !!(options === null || options === void 0 ? void 0 : options.fee), gasRate: options === null || options === void 0 ? void 0 : options.gasRate },
    });
}
exports.signDirect = signDirect;
function onAccountChanged(handler) {
    return window.cosmostation.tendermint.on('accountChanged', handler);
}
exports.onAccountChanged = onAccountChanged;
function offAccountChanged(event) {
    window.cosmostation.tendermint.off(event);
}
exports.offAccountChanged = offAccountChanged;
